import { useEffect, useState } from "react";

const KEY = "bw_loader_seen";

export const Loader = () => {
  const [hidden, setHidden] = useState(() => {
    if (typeof window === "undefined") return false;
    return sessionStorage.getItem(KEY) === "1";
  });
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (hidden) return;
    document.body.style.overflow = "hidden";
    const t1 = setTimeout(() => setFadeOut(true), 2200);
    const t2 = setTimeout(() => {
      setHidden(true);
      document.body.style.overflow = "";
      // sessionStorage: non-sensitive UI flag (loader already shown this session).
      sessionStorage.setItem(KEY, "1");
    }, 2800);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      document.body.style.overflow = "";
    };
    // Setters from useState are stable; module-level KEY is a constant.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hidden]);

  if (hidden) return null;

  return (
    <div
      data-testid="site-loader"
      className={`fixed inset-0 z-[999] flex items-center justify-center bg-[#0A0D14] transition-opacity duration-600 ${
        fadeOut ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      {/* subtle background pulse */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(212,175,55,0.10) 0%, rgba(10,13,20,1) 65%)",
        }}
      />
      <div className="relative flex flex-col items-center gap-8">
        <div className="loader-badge">
          <svg
            viewBox="0 0 120 120"
            width="120"
            height="120"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g transform="translate(60 60)">
              <rect
                x="-52" y="-52" width="104" height="104"
                transform="rotate(45)"
                fill="none" stroke="#D4AF37" strokeWidth="1"
                className="loader-ring"
              />
              <rect
                x="-38" y="-38" width="76" height="76"
                transform="rotate(45)"
                fill="none" stroke="#D4AF37" strokeWidth="0.6" opacity="0.55"
                className="loader-ring-inner"
              />
            </g>
            <text
              x="60" y="76" textAnchor="middle"
              fill="#D4AF37"
              fontFamily="Playfair Display, serif"
              fontSize="52" fontStyle="italic" fontWeight="500"
              className="loader-mono"
            >B</text>
            <circle cx="48" cy="18" r="1.6" fill="#D4AF37" className="loader-dot d1" />
            <circle cx="60" cy="14" r="2" fill="#D4AF37" className="loader-dot d2" />
            <circle cx="72" cy="18" r="1.6" fill="#D4AF37" className="loader-dot d3" />
          </svg>
        </div>
        <div className="text-center">
          <div className="loader-word font-serif-display text-white text-3xl sm:text-4xl tracking-wide">
            BONWORLD
          </div>
          <div className="loader-sub eyebrow mt-3" style={{ justifyContent: "center", display: "inline-flex" }}>
            Family Office · Singapore
          </div>
        </div>
      </div>

      <style>{`
        .loader-badge { animation: badgePop 900ms cubic-bezier(0.22,1,0.36,1) both; }
        .loader-ring { stroke-dasharray: 420; stroke-dashoffset: 420; animation: draw 1.4s cubic-bezier(0.22,1,0.36,1) forwards; }
        .loader-ring-inner { stroke-dasharray: 320; stroke-dashoffset: 320; animation: draw 1.4s 200ms cubic-bezier(0.22,1,0.36,1) forwards; }
        .loader-mono { opacity: 0; animation: fadeUp 700ms 600ms cubic-bezier(0.22,1,0.36,1) forwards; }
        .loader-dot { opacity: 0; }
        .loader-dot.d1 { animation: dotPop 300ms 1000ms cubic-bezier(0.22,1,0.36,1) forwards; }
        .loader-dot.d2 { animation: dotPop 300ms 1100ms cubic-bezier(0.22,1,0.36,1) forwards; }
        .loader-dot.d3 { animation: dotPop 300ms 1200ms cubic-bezier(0.22,1,0.36,1) forwards; }
        .loader-word { opacity: 0; letter-spacing: 0.6em; animation: wordIn 900ms 1000ms cubic-bezier(0.22,1,0.36,1) forwards; }
        .loader-sub { opacity: 0; animation: fadeUp 700ms 1500ms cubic-bezier(0.22,1,0.36,1) forwards; }

        @keyframes badgePop { from { transform: scale(0.9); opacity: 0; } to { transform: scale(1); opacity: 1; } }
        @keyframes draw { to { stroke-dashoffset: 0; } }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(8px);} to { opacity: 1; transform: translateY(0);} }
        @keyframes dotPop { from { opacity: 0; transform: scale(0.6);} to { opacity: 1; transform: scale(1);} }
        @keyframes wordIn { from { opacity: 0; letter-spacing: 0.6em; } to { opacity: 1; letter-spacing: 0.25em; } }
      `}</style>
    </div>
  );
};

export default Loader;
